import { capitalize, isObject, isString } from 'lodash';

const slotNames = {
  default: {
    one: 'slot',
    many: 'slots',
  },
  adult: {
    one: 'adult',
    many: 'adults',
  },
  passenger: {
    one: 'passenger',
    many: 'passengers',
  },
  ticket: {
    one: 'ticket',
    many: 'tickets',
  },
  seat: {
    one: 'seat',
    many: 'seats',
  },
  item: {
    one: 'item',
    many: 'items',
  },
  shirt: {
    one: 'shirt',
    many: 'shirts',
  },
  person: {
    one: 'person',
    many: 'people',
  },
  guest: {
    one: 'guest',
    many: 'guests',
  },
  player: {
    one: 'player',
    many: 'players',
  },
  student: {
    one: 'student',
    many: 'students',
  },
  share: {
    one: 'share',
    many: 'shares',
  }
};

export const formatMessage = (intl) => {
  return (...args) => {
    let settings, variables = {}, name = null;

    if (args.length === 3) {
      variables = Object.assign(args[1], variables);
      name = args[2];
    }

    if (args.length === 2) {
      if (isObject(args[1])) {
        variables = Object.assign(args[1], variables);
      }

      if (isString(args[1])) {
        name = args[1];
      }
    }
    const key = name ? `${args[0].id}_${name}` : args[0].id;

    if (intl.messages[key]) {
      settings = {
        id: key,
        defaultMessage: intl.messages[key],
      }
    } else if (intl.messages[args[0].id]) {
      settings = {
        id: args[0].id,
        defaultMessage: intl.messages[args[0].id],
      }
    } else {
      settings = {
        id: key,
        defaultMessage: args[0].defaultMessage,
      }
    }

    if (name && isValidName(name)) {
      variables.slotName = intl.messages[slotNames[name].one];
      variables.slotsName = intl.messages[slotNames[name].many];
      variables.SlotName = capitalize(intl.messages[slotNames[name].one]);
      variables.SlotsName = capitalize(intl.messages[slotNames[name].many]);
    } else {
      variables.slotName = intl.messages[slotNames['default'].one];
      variables.slotsName = intl.messages[slotNames['default'].many];
      variables.SlotName = capitalize(intl.messages[slotNames['default'].one]);
      variables.SlotsName = capitalize(intl.messages[slotNames['default'].many]);
    }

    return intl.formatMessage(settings, variables);
  };
}

const isValidName = (name) => {
  return !!slotNames[name];
}



// WEBPACK FOOTER //
// ./src/lib/intl.js